<template>
  <div
    class="relative inline"
    @mouseenter="onEnter"
    @mouseleave="onLeave"
  >
    <slot />
    <Teleport to="body">
      <div
        v-if="visible && description"
        class="fixed z-50 max-w-sm bg-white border border-gray-200 rounded-lg shadow-lg px-4 py-3"
        :style="popoverStyle"
        @mouseenter="onEnter"
        @mouseleave="onLeave"
      >
        <div class="text-xs text-gray-600 whitespace-pre-line leading-relaxed max-h-48 overflow-y-auto">
          {{ description }}
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  name: 'Support_DescriptionPopover',
  props: {
    description: { type: String, default: '' },
  },
  data() {
    return {
      visible: false,
      popoverStyle: {},
      timer: null,
    };
  },
  beforeUnmount() {
    clearTimeout(this.timer);
  },
  methods: {
    onEnter() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        const rect = this.$el.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const showAbove = spaceBelow < 200;
        this.popoverStyle = {
          left: rect.left + 'px',
          ...(showAbove
            ? { bottom: (window.innerHeight - rect.top + 4) + 'px' }
            : { top: (rect.bottom + 4) + 'px' }),
        };
        this.visible = true;
      }, 300);
    },
    onLeave() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.visible = false;
      }, 100);
    },
  },
};
</script>
